import React, { useState } from "react"
import { FullScreen, useFullScreenHandle } from "react-full-screen"
import { FaExpand } from "react-icons/fa"

import { Tooltip } from "components"
import classes from "./OhLalamoveMap.module.scss"

const OhLalamoveMap = props => {
  const { order } = props

  const [isInFullScreen, setIsInFullScreen] = useState(false)

  const handleClick = () => {
    fullscreenEnabled ?
      handle.enter() :
      window.open(lastQuotation?.shareLink, "_blank")
  }

  const handle = useFullScreenHandle()

  const lastQuotation =
    order.snapboxData?.[order?.snapboxData.length - 1]

  const fullscreenEnabled =
    document.fullscreenEnabled ||
    document.webkitFullscreenEnabled

  return (
    <div className={classes["lalamove-map"]}>
      <Tooltip title="Go fullscreen">
        <button
          className={classes["fullscreen-icon"]}
          onClick={handleClick}
        >
          <FaExpand />
        </button>
      </Tooltip>

      <FullScreen
        onChange={(state) => setIsInFullScreen(state)}
        handle={handle}
      >
        <iframe
          width="100%"
          title="snapbox"
          className={classes["iframe"]}
          src={lastQuotation?.shareLink}
          height={isInFullScreen ? "100%" : 400}
        />
      </FullScreen>
    </div>
  )
}

export default OhLalamoveMap